import React from 'react';
import Script from 'next/script';
import { MERCHANT_ID, banners, INTL_LOCALE, LOCALE } from '@/data/constants';
import { isPharmaprixBanner } from '@/utils';
import { useDetermineLocale } from '@/hooks';
import styles from './flyer.module.scss';

const Flyer = () => {
  const isPharmaprix = isPharmaprixBanner();
  const accessToken = isPharmaprix
    ? process.env.NEXT_PUBLIC_FLIPP_FLYER_ACCESS_TOKEN_PHX
    : process.env.NEXT_PUBLIC_FLIPP_FLYER_ACCESS_TOKEN_SDM;
  const { SDM, PHX } = MERCHANT_ID;
  const merchantId = isPharmaprix ? PHX : SDM;
  const merchantNameIdentifier = isPharmaprix ? banners.PHARMAPRIX : banners.SHOPPERS;

  const locale = useDetermineLocale();
  const { EN, FR } = INTL_LOCALE;
  const formattedLocale = locale === LOCALE.EN ? EN : FR;

  const onLoad = () => {
    const flippContainer = document.querySelector('#flipp-container');
    // @ts-ignore: Flipp Hosted Experience module
    const storefront = new Flipp.Storefront({
      accessToken,
      merchantId,
      merchantNameIdentifier,
      locale: formattedLocale,
    });
    storefront.renderStorefront(flippContainer);
  };

  return (
    <>
      <div id="flipp-container" data-testid="flipp-container" className={styles.flippContainer}></div>
      <Script
        src={`https://aq.flippenterprise.net/${merchantId}/iframe.js`}
        id={'flipp-storefront-script'}
        onLoad={onLoad}
      />
    </>
  );
};

export default Flyer;
